import React, { useState, useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { Store, updateSelectedMatch, updateError, updateMatchingTickets } from '../../../store';
import { userStore } from '../../../stores';
import TicketSearchResults from '../ArchiveSearchResults';
import LoadingIndicator from '../../SharedComponents/LoadingIndicator';
import { fetchMatches } from '../../../utils/helpers/asyncHelpers';
import './style.scss';

const ArchiveSearch = () => {
  const { state, dispatch } = useContext(Store);
  const { matchingTickets, errorType } = state;
  const [ticketString, setTicketString] = useState('');
  const [loading, setLoading] = useState(false);

  // Get token from userStore
  const token = userStore.access_token || '';

  const handleSumbit = async e => {
    e.preventDefault();
    setLoading(true);
    updateError({}, dispatch);

    await fetchMatches(ticketString, token, dispatch);

    updateSelectedMatch(null, dispatch);
    setLoading(false);
  };

  return (
    <div className={'ticket-search-wrapper'}>
      <form>
        <div className="search-input-container">
          <span className="search-icon">🔍</span>
          <input
            type="text"
            value={ticketString}
            onChange={e => setTicketString(e.target.value)}
            placeholder="Search by Ticket ID"
          />
        </div>
        <button type="submit" className="search-button" onClick={e => handleSumbit(e)}>
          SEARCH
        </button>
      </form>
      {loading && <LoadingIndicator />}
      {matchingTickets && <TicketSearchResults tickets={matchingTickets} token={token} />}
      {errorType?.errorType === 'invalid' && (
        <div className="invalid-character">{errorType.errorMessage}</div>
      )}
      {errorType && !loading && errorType.errorType === 'no results' && (
        <div className="no-matching-label">{errorType.errorMessage}</div>
      )}
    </div>
  );
};

export default observer(ArchiveSearch);
